// Utility for fetching listings from Spark API
export async function fetchListings({ agentId }) {
  try {
    let baseUrl = 'http://localhost:4000';
    
    // Use network IP when accessing from mobile device
    if (window.location.hostname === '192.168.4.177') {
      baseUrl = 'http://192.168.4.177:4000';
    } else if (import.meta.env.MODE === 'production' || import.meta.env.MODE === 'staging') {
      baseUrl = 'https://rmkp-open-houses.onrender.com';
    }
    
    const expandClause = "$expand=Media($filter=MediaCategory eq 'Photo'%3B$orderby=Order asc)";
    const url = `${baseUrl}/api/listings?agentId=${agentId}&${expandClause}`;
    
    const res = await fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'X-Agent-ID': agentId,
      },
      credentials: import.meta.env.MODE === 'production' ? 'include' : 'same-origin'
    });
    
    if (!res.ok) {
      const errorData = await res.json().catch(() => ({}));
      console.error('API Error:', errorData);
      throw new Error(errorData.error || `HTTP error! status: ${res.status}`);
    }
    
    const data = await res.json();
    return data.value || [];
  } catch (error) {
    console.error('Error in fetchListings:', {
      message: error.message,
      name: error.name,
      stack: error.stack,
      agentId,
      env: import.meta.env.MODE,
    });
    throw error;
  }
}

// Helper for agent role (kept for possible future use)
export function getAgentRole(listing, agentId) {
  if (listing.ListAgentKey === agentId || listing.CoListAgentKey === agentId) return 'Listing Agent';
  if (listing.BuyerAgentKey === agentId || listing.CoBuyerAgentKey === agentId) return 'Buyside Agent';
  return '';
}
